<template>
  <div>
    <div class="fsk16_overlay"></div>
    <jwplayer ref="jwplayer" :options="this.$manager.jwOptions"></jwplayer>
  </div>
</template>

<script>

  import PlayerMixin from '../mixins/PlayerMixin.vue'
  import axios from 'axios'

  export default {

    name: 'VideoServicePlayer',

    mixins: [PlayerMixin],

    props: {
      videoCbinId: {
        required: false
      },
      videoVipoId: {
        required: false
      },
      playlistId: {
        required: false
      },
      api: {
        required: false,
        default () {
          return 'https://p-boby-connect-akamai.rtl2apps.de/rtl2/videocbin/' //1100039586
        }
      }
    },

    data () {
      return {
        videoData: null,
        relatedPlugin: null,
        showRelated: false
      }
    },

    computed: {
      videoDataUrl() {

        if(this.videoCbinId) {
          return this.$settings && this.$settings.videoService ? this.$settings.videoService.baseUrl + 'video/' + this.videoCbinId : ''
        }

        if(this.videoVipoId) {
          return this.$settings && this.$settings.videoService ? this.$settings.videoService.baseUrl + 'video/vipo/' + this.videoVipoId : ''
        }

        return null;
      },

      playlistDataUrl() {
        return this.playlistId && this.$settings && this.$settings.videoService ? this.$settings.videoService.baseUrl + 'jw-playlist/' + this.playlistId : ''
      },

      recommendation_url () {

        if(this.videoData && this.videoData.recommendation) {
          return this.videoData.recommendation;
        }

        if(this.videoCbinId) {
          return this.playlistId && this.videoCbinId && this.$settings && this.$settings.videoService ? this.$settings.videoService.baseUrl + 'jw-playlist/' + this.playlistId + '/' + this.videoCbinId : ''
        }
        if(this.videoData && this.videoData.videoId) {
          return this.playlistId && this.videoData.videoId && this.$settings && this.$settings.videoService ? this.$settings.videoService.baseUrl + 'jw-playlist/' + this.playlistId + '/' + this.videoData.videoId : ''
        }
        else {
          return this.playlistId && this.$settings && this.$settings.videoService ? this.$settings.videoService.baseUrl + 'jw-playlist/' + this.playlistId : ''
        }

      }
    },

    mounted () {

      if(this.videoCbinId && this.playlistId) {
        this.showRelated = true;
        this.loadVideoData()
      }

      else if(this.videoVipoId && this.playlistId) {
        this.showRelated = true;
        this.loadVideoData()
      }

      else if (this.playlistId) {
        this.showRelated = true;
        this.loadPlaylistData()
      }

      else if (this.videoCbinId) {
        this.loadVideoData();
      }

    },

    methods: {

      loadPlaylistData () {
        this.$l.log('loading playlistId', this.playlistId)

        axios.get( this.playlistDataUrl, {}).then((response) => {
          this.videoData = response.data[0];

          this.$l.log('loaded', this.videoData);

          this.videoData.streamUrl = this.videoData.streamUrl.replace(/^http:\/\//i, 'https://');

          this.$manager.addItemData({
            source: 'videoservice',
            id: this.videoData.videoId,
            title: this.videoData.title,
            description: this.videoData.description,
            poster: this.videoData.image,
            format: this.videoData.formatTitle,
            formatId: this.videoData.formatId,
            duration: this.videoData.duration,
            adZone: this.videoData.adTheme,
            ageRating: this.videoData.ageRating,
            playlistId: this.videoData.playlistId,
            boId: this.videoData.boId,
            boNr: this.videoData.boNr,
            validFrom: this.videoData.validFrom,
            createdAt: this.videoData.created_at,
          });

          this.setupVideo()

        }).catch((error) => {
          this.$warn('VIDEOSERVICE API Error', error)
          this.$events.fire('fatalError', {msg: 'Fehler beim laden der Videodaten :('})
        });
      },

      /**
       * Metadaten werden von VIPO API geladen
       *
       * @author Thomas Petautschnig [tp@catdev.de]
       * @return {[type]} [description]
       */
      loadVideoData () {
        this.$l.log('loading videoCbinId/videoVipoId', this.videoCbinId, this.videoVipoId);

        axios.get( this.videoDataUrl, {}).then((response) => {
          this.videoData = response.data;

          this.$l.log('loaded', this.videoData);

          this.videoData.streamUrl = this.videoData.streamUrl.replace(/^http:\/\//i, 'https://');

          // videoId: 211,
          // viviId: null,
          // sequenceNumber: null,
          // cobhId: 1100039586,
          // formatId: 3373,
          // boNr: "070-018856-0022",
          // boId: 178163,
          // title: "Chethrin war die größte Lästerhexe!",
          // formatTitle: "Love Island",
          // description: "Mike hat nach Love Island noch so einiges über die anderen Islander und seine Zeit in der Villa zu erzählen. Der 25-Jährige verrät, welches Mädel er so richtig hot findet und mit wem er auf Love Island so gar nichts anfangen konnte.",
          // duration: 90,
          // seoTitle: "Mike hat nach Love Island noch so einiges über die anderen Islander und seine Zeit in der Villa zu e",
          // seoDescription: "Mike hat nach Love Island noch so einiges über die anderen Islander und seine Zeit in der Villa zu e",
          // streamUrl: "http://trans01dach-vh.akamaihd.net/i/delivery/7b/e4/7be4bf19-e07d-4b82-a690-a9f5c989ddc8/01SZ2D0010333WVB_,65,3850,650,1000,2350,250,1350,k.mp4.csmil/master.m3u8",
          // image: "http://p-assets1.rtl2.de/4238199_01sz2d0010333wvb_video-love-island-interview-mike.png",
          // ageRating: 16,
          // creationDate: "2017-10-13T13:13:07.9+02:00",
          // lastModifiedDate: "2017-10-13T13:00:18.967+02:00",
          // playlists: [ ],
          // playlistsIds: [ ]


          this.$manager.addItemData({
            source: 'videoservice',
            id: this.videoData.videoId,
            title: this.videoData.title,
            description: this.videoData.description,
            poster: this.videoData.image,
            format: this.videoData.formatTitle,
            formatId: this.videoData.formatId,
            duration: this.videoData.duration,
            adZone: this.videoData.adTheme,
            ageRating: this.videoData.ageRating,
            playlistId: this.videoData.playlistId,
            boId: this.videoData.boId,
            boNr: this.videoData.boNr,
            validFrom: this.videoData.validFrom,
            createdAt: this.videoData.created_at,
            videoType: this.videoData.videoType,
            timeOfPublication: this.videoData.timeOfPublication,
            perspective: this.videoData.perspective,
            materialType: this.videoData.materialType,
            streamId: this.$helpers.uuidv4()
          });


          this.setupVideo()
        }).catch((error) => {
          this.$warn('VIDEOSERVICE API Error', error)
          this.$events.fire('fatalError', {msg: 'Fehler beim laden der Videodaten :('})
        })
      },

      /**
       * JWPlayer Setup
       *
       * @author Thomas Petautschnig [tp@catdev.de]
       * @return {[type]} [description]
       */
      setupVideo () {

        var video = this.videoData;

        if(video.adTheme) {
            this.$videoAdSchedule.setup({
                duration: video.duration,
                streamurl: this.$helpers.streamToHttps(video.streamUrl),
                zone: 'rtl2_rtl2/'+video.adTheme,
                fsk16: video.ageRating >= 16
            })

            if(this.$settings.ads && !video.adFree && !video.adFreeFormat) {

                this.$videoAdSchedule.activate()

                // Settings übernehmen
                this.$l.log('adSchedule setup', this.$videoAdSchedule.adSchedule)
                this.$manager.addOptions('advertising', {
                    schedule: this.$videoAdSchedule.adSchedule
                })
            }
            else {
                this.$l.log('adSchedule setup skipped!')
            }
        }


        if(this.showRelated) {
          this.$manager.addOptions({
            nextUpDisplay: true,

            related: {
              file: video.recommendation || this.recommendation_url,
            }
          })
        }


        // Playliste übernehmen
        this.$manager.addPlaylist([{
          title: video.title,
          description: video.description,
          image: video.image,
          sources: [{
            file: this.$helpers.streamToHttps(video.streamUrl),
            type: 'hls'
          }]
        }])

        // Setup fertig
        this.$manager.finalizeSetup()
      }


    },

    events: {

      jwRelatedReady() {
        this.relatedPlugin = this.$jwplayer.getPlugin('related');
        var vm = this;

        if(this.relatedPlugin) {
            // vm.$l.log('relatedPlugin getPlaylist', this.$jwplayer.getPlaylist())
            // vm.$l.log('relatedPlugin', this.relatedPlugin)
            // debugger;
          this.relatedPlugin.on('open', function(obj) {
            vm.$l.log('related opened', obj)
          })

          this.relatedPlugin.on('nextUp', function(obj) {
              // debugger;
              // this means we have a video ready for "revolverplay"
              // = the related playlist has found a match!!
              vm.$l.log('related nextUp', obj)

              // this is not working:
              // delete this.playerModel.attributes.advertising.schedule.preroll;

              // debugger;
          })
        }
      },

      jwPlaylist(evt) {
        const item = evt.playlist[0];

        this.$l.log('jwPlaylist', item)

        if(typeof item.id !== 'undefined') {
          this.$videoAdSchedule.setup({
            duration: item.seconds || item.duration,
            streamurl: this.$helpers.streamToHttps(item.sources[0].file),
            zone: 'rtl2_rtl2/'+item.adTheme
          });

          this.$l.log('adSchedule', this.$videoAdSchedule.adSchedule);

          item.adschedule = this.$videoAdSchedule.adSchedule;
          item.schedule = this.$videoAdSchedule.adSchedule;
          // item.adSchedule = this.$videoAdSchedule.adSchedule;
          item.fun = 'oink';
        }
      },

      jwPlaylistItem(evt) {
        this.$l.log('playlist playing id', evt.item.id, evt.item)

        if(typeof evt.item.id !== 'undefined') {

          let itemData = {
            source: 'videoservice',
            id: evt.item.id,
            title: evt.item.title,
            description: evt.item.description,
            poster: evt.item.image,
            format: evt.item.formatTitle,
            formatId: evt.item.formatId,
            duration: evt.item.duration,
            adZone: evt.item.adTheme,
            collection: evt.item.playlistId,
            // collectionName: evt.item.vico_mt_titel,
            permalink: evt.item.link,
            ageRating: evt.item.ageRating,
            playlistId: evt.item.playlistId,
            boId: evt.item.boId,
            boNr: evt.item.boNr,

            validFrom: evt.item.validFrom,
            createdAt: evt.item.created_at,

            videoType: evt.item.videoType,
            timeOfPublication: evt.item.timeOfPublication,
            perspective: evt.item.perspective,
            materialType: evt.item.materialType,

            streamId: this.$helpers.uuidv4()
          }

          this.$manager.addItemData(itemData);

          window.parent.postMessage({action: 'newItemData', item: itemData}, '*');
        }
        else {
            this.$manager.refreshStreamId();
        }

      }

    }

  }
</script>



// WEBPACK FOOTER //
// src/components/VideoService.vue